<template>
   <div class="user_profile_wrap password_wrap">
        <div class="title">{{get_local_string.string_45}}</div>
        <form  @submit.prevent="change_password_submit()">
         <b-field :label="get_local_string.string_65" label-position="on-border" 
             :type="{ 'is-danger': hasError }"
            :message="{ [msg1]: hasError }"
             
         >
            <b-input type="password" v-model="pass_obj.current_password"  password-reveal  @keyup.native="on_write_pass()" maxlength="30"></b-input>
            <!-- :value="user.name" -->
        </b-field>
         <b-field :label="get_local_string.string_66" label-position="on-border"
            :type="{ 'is-danger': hasError2 }"
            :message="{[msg2]:hasError2}">
            <b-input type="password" v-model="pass_obj.new_password"  password-reveal  @keyup.native="on_write_pass()" maxlength="30"></b-input>
        </b-field>
         <b-field :label="get_local_string.string_67"  label-position="on-border" 
         :type="{ 'is-danger': hasError3 }"
            :message="{ [msg3]: hasError3 }"
         >
            <b-input type="password" v-model="pass_obj.confirm_password"  password-reveal @keyup.native="on_write_pass()" maxlength="30"></b-input>
        </b-field >
        <b-button :disabled="disabled" :loading="loading" class="savebtn"  native-type="submit" type="is-success">{{get_local_string.string_51}}<ion-icon name="checkmark-done-circle-outline"></ion-icon></b-button>
        </form>
   </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    name:'passwordprofile',
    data(){
        return{
            hasError: false,
            hasError2:false,
            hasError3:false,
            msg1:'',
            msg2:'',
            msg3:'',
            disabled:true,
            loading:false,
             pass_obj:{
             current_password:'',
             new_password:'',
             confirm_password:''
             },
             errorMsg:''
        }
    },
    computed:{
        ...mapGetters({
         get_local_string:'get_local_string'
    })
    },
    methods:{
        ...mapActions({
            change_password_api:'change_password_api'
        }),
        on_write_pass(){
           if(this.pass_obj.current_password=='' || this.pass_obj.new_password=='' || this.pass_obj.confirm_password=='')
           {
               this.disabled = true;
               this.hasError  =true;
               this.hasError2  =true;
               this.hasError3  =true;
               this.msg1 = 'current password is requeried';
               this.msg2 = 'new password is requeried';
               this.msg3 = 'confirm password is requeried';
           }else{
               this.disabled = false;
               this.hasError  =false;
               this.hasError2  =false;
               this.hasError3  =false;
           }
            // current pass
          if(this.pass_obj.current_password==''){
                this.hasError  =true;
                 this.msg1 = 'current password is requeried';
                this.disabled = true;
           }
            else if(this.pass_obj.current_password!=''){
                if(this.pass_obj.current_password.length<8)
                {
               this.msg1 = 'current password is short';
               this.disabled = true;
               this.hasError  =true;
                }else{
               this.disabled = false;
               this.hasError  =false;
                }
              
           }
        //    new pass
        if(this.pass_obj.new_password==''){
                this.hasError2  =true;
                 this.msg2 = 'new password is requeried';
                this.disabled = true;
           }
           else if(this.pass_obj.new_password!=''){
               if(this.pass_obj.new_password.length<8)
                {
               this.msg2 = 'new password is short';
               this.disabled = true;
               this.hasError2  =true;
                }else{
               this.disabled = false;
               this.hasError2  =false;
                }
           }

           if(this.pass_obj.confirm_password==''){
                this.hasError3  =true;
                this.msg3 = 'confirm password is requeried';
                this.disabled = true;
           }
           else if(this.pass_obj.confirm_password!=''){
            if(this.pass_obj.confirm_password.length<8)
                {
               this.msg3 = 'new password is short';
               this.disabled = true;
               this.hasError3  =true;
                }else{
               if(this.pass_obj.confirm_password != this.pass_obj.new_password){
            //   console.log('not equal')
               this.msg3 = 'confirm password is not match';
               this.disabled = true;
               this.hasError3  =true;
             }else{
               this.disabled = false;
             }
                }
           }

           
         
       },
       change_password_submit(){
           this.loading = true;
           let password_obj = {
               'password_current':this.pass_obj.current_password,
               'password':this.pass_obj.new_password,
               'password_confirmation':this.pass_obj.confirm_password
           }
           this.change_password_api(password_obj).then((res)=>{
             if(res.status == 200){
                this.errorMsg =`<b>Password changed successfully</b>`;
                this.pass_obj.current_password='';
                this.pass_obj.new_password='';
                this.pass_obj.confirm_password='';
                 this.loading = false;
                this.success();
                 this.disabled = true;
             }
             else{
                this.errorMsg =`<b>${res.message}</b>`;
                this.loading = false;
                this.danger();
             }
           })
       },
        // MSG ALERT
        success() {
          const notif = this.$buefy.notification.open({
              duration: 4000,
              message: this.errorMsg,
              position: 'is-bottom-right',
              type: 'is-success',
              hasIcon: true
          })
          notif.$on('close', () => {
              // this.$buefy.notification.open('Custom notification closed!')
          }
          )
      },
        danger() {
                const notif = this.$buefy.notification.open({
                    duration: 4000,
                    message: this.errorMsg,
                    position: 'is-bottom-right',
                    type: 'is-danger',
                    hasIcon: true
                })
                notif.$on('close', () => {
                    // this.$buefy.notification.open('Custom notification closed!')
                }
                )
            },
    }
}
</script>
<style lang="scss" >
  .password_wrap{
      .icon{
          i{
              color: white !important;
          }
    }
    .field.is-floating-label .input:focus, .field.is-floating-label .textarea:focus, .field.is-floating-label .select select:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
    border-color: white !important;
}
  }
  
</style>
<style lang="scss" scoped>
.user_profile_wrap{
.title{
    font-size: 30px;
    position: relative;
    display: inline-block;
    padding-top: 10px;
    color: var(--active_color);
    border-bottom: 3px solid var(--active_color);
    padding-bottom: 6px;
    }
}
</style>